<template>
  <div>
    <div class="notice-list mt20 mb20">
      <el-tabs
        class="notice-list-tabs"
        v-model="tabName"
        @tab-click="handleClick"
      >
        <!--评标结果-->
        <el-tab-pane
          :label="$t('page.content.labelMenu1')"
          name="3"
          class="notice-list-group clearfix"
        >
          <template v-for="(item, index) in nodeList3">
            <a @click="handleViewDetail(item)" :key="index">
              <span class="ellipsis" :title="item.noticeTitle">{{
                item.noticeTitle
              }}</span>
              <span>{{
                item.noticeStartTime
                  ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </a>
          </template>
        </el-tab-pane>
        <!--流标公告-->
        <!--<el-tab-pane-->
        <!--:label="$t('page.content.labelMenu2')"-->
        <!--name="8"-->
        <!--class="notice-list-group clearfix"-->
        <!--&gt;-->
        <!--<template v-for="(item, index) in nodeList8">-->
        <!--<a @click="handleViewDetail(item)" :key="index">-->
        <!--<span class="ellipsis" :title="showNoticeTitle(item)">{{-->
        <!--showNoticeTitle(item)-->
        <!--}}</span>-->
        <!--<span>{{-->
        <!--item.noticeStartTime-->
        <!--? moment(item.noticeStartTime).format("YYYY-MM-DD")-->
        <!--: ""-->
        <!--}}</span>-->
        <!--</a>-->
        <!--</template>-->
        <!--</el-tab-pane>-->
        <!--补遗公告-->
        <!--<el-tab-pane-->
        <!--:label="$t('page.content.labelMenu3')"-->
        <!--name="7"-->
        <!--class="notice-list-group clearfix"-->
        <!--&gt;-->
        <!--<template v-for="(item, index) in nodeList7">-->
        <!--<a @click="handleViewDetail(item)" :key="index">-->
        <!--<span class="ellipsis" :title="showNoticeTitle(item)">{{-->
        <!--showNoticeTitle(item)-->
        <!--}}</span>-->
        <!--<span>{{-->
        <!--item.noticeStartTime-->
        <!--? moment(item.noticeStartTime).format("YYYY-MM-DD")-->
        <!--: ""-->
        <!--}}</span>-->
        <!--</a>-->
        <!--</template>-->
        <!--</el-tab-pane>-->
        <!-- <el-tab-pane
          :label="$t('page.content.labelMenu4')"
          name="2"
          class="notice-list-group clearfix"
        >
          <template v-for="(item, index) in nodeList2">
            <a @click="handleClickInviteNotice(item)" :key="index">
              <span class="ellipsis" :title="item.noticeTitle">{{
                item.noticeTitle
              }}</span>
              <span>{{
                item.noticeStartTime
                  ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </a>
          </template>
        </el-tab-pane>-->
        <!--中标通知-->
        <el-tab-pane
          :label="$t('page.content.labelMenu5')"
          name="4"
          class="notice-list-group clearfix"
        >
          <template v-for="(item, index) in nodeList4">
            <a @click="handleViewDetail(item)" :key="index">
              <span class="ellipsis" :title="item.noticeTitle">{{
                item.noticeTitle
              }}</span>
              <span>{{
                item.noticeStartTime
                  ? moment(item.noticeStartTime).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </a>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-link
        :underline="false"
        type="info"
        style="transform: translateY(5px)"
        class="notice-list-view-all"
        @click="handleViewAll(tabName)"
        >{{ $t("page.content.MoreAndMore") }} ></el-link
      >
    </div>
    <div class="notice-list mt20 mb20">
      <el-tabs class="notice-list-tabs">
        <!--业务公告-->
        <el-tab-pane
          :label="$t('page.content.serviceAnnouncement')"
          class="notice-list-group clearfix"
        >
          <template v-for="(item, index) in pageData">
            <a @click="handleOp(item)" :key="index">
              <span class="ellipsis" :title="item.title">{{ item.title }}</span>
              <span>{{
                item.publishTime
                  ? moment(item.publishTime).format("YYYY-MM-DD")
                  : ""
              }}</span>
            </a>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-link
        :underline="false"
        type="info"
        class="notice-list-view-all"
        @click="handleViewAll('业务')"
        style="transform: translateY(5px)"
        >{{ $t("page.content.MoreAndMore") }} ></el-link
      >
    </div>
  </div>
</template>

<script>
import {
  listSupBidNotice,
  queryPublishedNoticeList
} from "@/app/shop/api/shopping";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "noticeList",
  mixins: [mixinHomePage],
  data() {
    return {
      nodeList3: [],
      nodeList2: [],
      nodeList4: [],
      nodeList7: [],
      nodeList8: [],
      pageData: [],
      tabName: "3",
      moment: moment,
      loginInfo: this.$store.state.user.loginInfo || {},
      supOrPur: ""
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  methods: {
    init() {
      if (
        this.supInfo.getSupInfoByLoginInfoRspBOList &&
        this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
      ) {
        this.supOrPur = "sup";
      } else {
        this.supOrPur = "pur";
      }
      this.getNoticeList({
        noticeType: 3
      });
      this.publicNotice();
    },
    publicNotice() {
      queryPublishedNoticeList({
        pageNo: 1,
        pageSize: 5,
        module: 1,
        pageState: 2,
        textType: 3,
        appId: 100123
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data.rows.filter(item => {
            return item.textType == 3;
          });
        }
      });
    },
    getNoticeList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      let params = {
        noticeStatusEndFlag: 1,
        pageNo: 1,
        pageSize: 5,
        supCodeList: supCodeList
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      Object.assign(params, obj);
      listSupBidNotice(params).then(res => {
        if (res.data.code === "0") {
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.$set(this, "nodeList" + params.noticeType, res.data.data.rows);
          }
        }
      });
    },
    handleClick(data) {
      this.tabName = data.name;
    },
    isLogin() {
      if (Cookies.get("access_token")) {
        return true;
      } else {
        this.$message({
          message: this.$t("page.content.loginTip"),
          type: "warning",
          offset: document.documentElement.clientHeight / 2 - 21
        });
        return false;
      }
    },
    handleOp(row) {
      // let url = this.$router.resolve({
      //   path: "/announcementDetail",
      //   query: {
      //     id: row.noticeInfoId,
      //     type: this.type
      //   }
      // });
      let params = ["id=" + row.noticeInfoId];
      let url = "/announcementDetail?" + params.join("&");
      window.open(window.location.origin + url, "_blank");
    },
    handleViewDetail(row) {
      let url = this.$router.resolve({
        path: "/viewNoticeSimpleDetail",
        query: {
          type: this.tabName,
          schemeId: row.schemeId,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          supCode: row.supCode,
          supName: row.supName
        }
      });
      // let params = [
      //   "type=" + this.tabName,
      //   "schemeId=" + row.schemeId,
      //   "schemeName=" + row.schemeName,
      //   "schemeCode=" + row.schemeCode,
      //   "noticeId=" + row.noticeId,
      //   "opUnitName=" + row.opUnitName,
      //   "supCode=" + row.supCode,
      //   "supName=" + row.supName
      // ];
      // let url = "/viewNoticeSimpleDetail?" + params.join("&");
      // window.open(window.location.origin + url, "_blank");
      window.open(url.href, "_blank");
    },
    handleViewAll(type) {
      if (type === "2") {
        //邀请公告
        let params = ["type=" + type];
        let url = "/searchList?" + params.join("&");
        window.open(window.location.origin + url, "_blank");
        // let url = this.$router.resolve({
        //   path: "/searchList",
        //   query: {
        //     type: type
        //   }
        // });
        // window.open(url.href, "_blank");
      } else if (type == "业务") {
        let url = "/announcementsList";
        window.open(window.location.origin + url, "_blank");
        // let url = this.$router.resolve({
        //   path: "/announcementsList"
        // });
        // window.open(url.href, "_blank");
      } else {
        let params = ["type=" + type, "source=1"];
        let url = "/announcementsList?" + params.join("&");
        window.open(window.location.origin + url, "_blank");

        // let url = this.$router.resolve({
        //   path: "/announcementsList",
        //   query: {
        //     type: type,
        //     source: "1"
        //   }
        // });
        // window.open(url.href, "_blank");
      }
    }
  },
  computed: {
    showNoticeTitle() {
      return item => {
        //       return item => {https://docs.qq.com/sheet/DQkdUaFNHenVIc0VY?tab=jw2dyn 68行
        // if (item.supName) {
        //   return `[${item.supName}]${item.noticeTitle}`;
        // } else {
        //   return item.noticeTitle;
        // }
        return item.noticeTitle;
      };
    },
    supInfo() {
      return this.$store.state.user.supInfo || {};
    }
  },
  watch: {
    tabName(val) {
      switch (val) {
        case "3": //评标结果
          this.getNoticeList({
            noticeType: 3
          });
          break;
        case "2": //邀请公告
          if (this.isLogin()) {
            this.getNoticeList({
              noticeType: 2
            });
          }
          break;
        case "4": //中标通知
          if (this.isLogin()) {
            this.getNoticeList({
              noticeType: 4
            });
          }
          break;
        case "7": //补遗公告
          this.getNoticeList({
            noticeType: 7,
            purSupFlag: this.supOrPur
          });
          break;
        case "8": //流标公告
          this.getNoticeList({
            noticeType: 8,
            purSupFlag: this.supOrPur
          });
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 20px;
}
.notice-list .notice-list-group a:nth-child(2n) {
  margin-left: 0;
}
.notice-list {
  width: 50%;
  float: left;
}
</style>
